import { defineFieldDisplay } from "../defines";
import UserDisplay from "./user-display.vue";

export default defineFieldDisplay({
  id: "user",
  component: UserDisplay,
  fields: ["id", "avatar.id", "email", "first_name", "last_name"],
});
